import { makeAutoObservable } from "mobx";

import MessageModel from "../model/MessageModel";
import messageRepository from "../repository/MessageRepository";

/**
 * 메시지 Store
 */
class MessageStore {
  constructor() {
    makeAutoObservable(this);
  }

  private _model!: MessageModel;

  public get model() {
    return this._model;
  }

  private set model(model: MessageModel) {
    this._model = model;
  }

  public async readAll(repeat?: boolean) {
    const result = await messageRepository.get();

    if (result != null) {
      const newModel = new MessageModel(result);

      if (JSON.stringify(newModel) !== JSON.stringify(this._model)) {
        this.model = newModel;
      }
    }

    if (repeat && this.model && this.model.cacheSeconds > 0) {
      window.setTimeout(() => this.readAll(repeat), this.model.cacheSeconds * 1000);
    }
  }

  public getMessage(code: string): string | undefined {
    if (this.model && this.model.properties) {
      return this.model?.properties[code];
    }
  }
}

const messageStore = new MessageStore();

export default messageStore;
